import React from "react";
import { Box, Button, Paper, TextField } from "@mui/material";
import Colors from "../Constant/Colors";
import Work from "@mui/icons-material/Work";
import Search from "@mui/icons-material/Search";
import Footer from "../components/Footer/Footer"
import { Link } from "react-router-dom";
export default function Registrationform() {
  return (
    <>
      <Box display="flex" justifyContent="center" alignItems="center" mt="65px" mb="60px">
        <Paper
          display="flex"
          justifyContent="center"
          alignItems="center"
          elevation={5}
          sx={{
            backgroundColor: "white",
            marginTop: "25px",
            borderRadius: 3,
            padding: "35px",
            width: "50%",
          }}
        >
          <h4 style={{ textAlign: "center", fontSize: "2rem" }}>
            Join as Designer or Recruiter
          </h4>
          <Box   >
            <Link to="/register/designer-registration" style={{textDecoration:"none"}} >
            <Button
              variant="outlined"
              sx={{
                marginTop: 6,
                borderRadius: "10px",
                padding: "10px 20px",
                color: Colors.primary,
                fontWeight: "600",
                letterSpacing: 1,
                "&:hover": {
                  backgroundColor: Colors.secondary,
                  color: "black",
                },
              }}
            >
             <Search sx={{ fontSize: "50px",padding:"5px" }} /> I'M Designer looking for job
            </Button>
            </Link>
          </Box>
          <Box >
            <Link to="/register/recruiter-registration" style={{textDecoration:"none"}} >
            <Button
              variant="outlined"
              sx={{
                marginTop: 6,
                borderRadius: "10px",
                padding: "10px 20px ",
                color: Colors.primary,
                fontWeight: "600",
                letterSpacing: 1,
                "&:hover": {
                  backgroundColor: Colors.secondary,
                  color: "black",
                },
              }}
            >
              <Work sx={{ fontSize: "50px" ,padding:"5px",marginRight:"7px" }} />
              I'M Recruiter hiring for job or project
            </Button>
            </Link>
          </Box>
        </Paper>
      </Box>
      <Footer />

    </>
  );
}
